import React from 'react'
import { UserAvatar } from 'containers'
import { Avatar } from 'components/atoms'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

const UsersAvatarList = ({ users, maxItems, loading }) => {
  if (loading) {
    return (
      <Avatar modifiers={['bgLighterS']} loading />
    )
  }
  return (
    <List>
      {users.map(
        (user, index) => {
          if (index === maxItems) {
            return (
              <More key={user.value}>
                +
                {users.length - maxItems}
              </More>
            )
          }
          if (index > maxItems) return null
          return (
            <Item key={user.value}>
              <UserAvatar
                userId={user.value}
                name={user.label}
                modifiers={['bgLighterS']}
                shouldInteract={false}
              />
            </Item>
          )
        }
      )}
    </List>
  )
}


const Item = styled.div`
`

const More = styled.div`
  height: 2rem;
  padding: ${props => props.theme.spacing.xs2};
  background-color: ${props => props.theme.colors.bgLighterS};
  color: ${props => props.theme.colors.baseLighter};
  font-size: ${props => props.theme.sizes.xs};
  display: flex;
  align-items: center;
  justify-content: center;
`

const List = styled.div`
  display: flex;
  ${Item} {
    padding-right: ${props => props.theme.spacing.xs3};
  }
  ${Item}:last-child {
    padding-right: 0;
  }
`


UsersAvatarList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  maxItems: PropTypes.number,
  loading: PropTypes.bool,
}

UsersAvatarList.defaultProps = {
  users: [],
  maxItems: 3,
  loading: false
}

export default UsersAvatarList
